import React, { useEffect, useState, useMemo } from "react";
import AnimatedMainContainer from "../../../components/AnimatedMainContainer";
import { useIntl } from "react-intl";
import {
  Container,
  NewButton,
  TitleContainer,
  Title,
  CardHeader,
  DeleteIcon,
  IconsDiv,
  Cards,
  LabelInfo,
  ViewButton,
  ContentContainer,
  FlexContainer,
} from "../styles";
import { FaPlus } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";
import { MdWarning } from "react-icons/md";

import { Divider, Empty, Spin, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { deleteTotem, getAllTotems } from "../../../service/manage.access";
import { useHistory } from "react-router-dom";
import api from "../../../service";
import { useToast } from "../../../hooks/toast";
import ConfirmationModal from "../../../components/ConfirmationModal";
import SelectWithInternalLabel from "../../../newUXComponents/SelectWithInternalLabel";

const AdminManegeTotemAccess = () => {
  const intl = useIntl();
  const { token } = useSelector((state) => state.auth);
  const [totems, setTotems] = useState([]);
  const history = useHistory();
  const { addToast } = useToast();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedIdToDelete, setSelectedIdToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [eventFilter, setEventFilter] = useState("all");
  const [areaFilter, setAreaFilter] = useState("all");

  useEffect(() => {
    handleAllTotems();
  }, []);

  const handleAllTotems = async () => {
    try {
      setIsLoading(true);

      const responseTotems = await getAllTotems({ token });

      const responseEvents = await api.get("/admin/events", {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      const eventsList = responseEvents.data.output;

      const mappedTotems = responseTotems.data.totems.map((totem) => {
        const match = eventsList.find((ev) => ev.idNumber === totem.eventId);

        return {
          ...totem,
          eventEditionName: match
            ? match.eventEditionName
            : "Evento não encontrado",
        };
      });

      setTotems(mappedTotems || []);
    } catch (err) {
      console.error("Erro ao buscar totems:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteTotem = async (id) => {
    try {
      await deleteTotem({ token, id });
      addToast({
        type: "success",
        title: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({
          id: "success.deleted_totem",
        }),
      });
      await handleAllTotems();
    } catch (error) {
      if (error.response?.data?.code === -50010 || error.response?.data?.code === -50014 || error.response?.data?.code === -50017) {
        addToast({
          type: "error",
          title: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({
            id: "api.error." + error.response?.data?.code,
          }),
        });
      } else {
        addToast({
          type: "error",
          title: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({
            id: "error.deleting_totem",
          }),
        });
      }
    } finally {
      setModalIsOpen(false);
    }
  };

  const filteredTotems = useMemo(() => {
    return totems.filter((item) => {
      const matchesEvent =
        eventFilter === "all" || item.eventId === eventFilter;

      const matchesArea = areaFilter === "all" || item.areaName === areaFilter;

      return matchesEvent && matchesArea;
    });
  }, [totems, eventFilter, areaFilter]);

  const eventOptions = useMemo(() => {
    const base =
      areaFilter === "all"
        ? totems
        : totems.filter((t) => t.areaName === areaFilter);

    return Array.from(
      new Map(
        base.map((ev) => [
          ev.eventId,
          {
            label: ev.eventEditionName,
            value: ev.eventId,
          },
        ])
      ).values()
    ).sort((a, b) => a.label.localeCompare(b.label));
  }, [totems, areaFilter]);

  const areaOptions = useMemo(() => {
    const base =
      eventFilter === "all"
        ? totems
        : totems.filter((t) => t.eventId === eventFilter);

    return Array.from(
      new Map(
        base.map((ar) => [
          ar.areaName,
          {
            label: ar.areaName,
            value: ar.areaName,
          },
        ])
      ).values()
    ).sort((a, b) => a.label.localeCompare(b.label));
  }, [totems, eventFilter]);

  return (
    <AnimatedMainContainer
      breadcrumb={intl.formatMessage({ id: "breadcumb.manage_access" })}
    >
      <Spin spinning={isLoading}>
        <Container>
          <TitleContainer>
            <FlexContainer>
              <Title>{intl.formatMessage({ id: "totems" })}</Title>
              <FlexContainer>
                <SelectWithInternalLabel
                  label={
                    intl.formatMessage({
                      id: "event",
                    }) + ":"
                  }
                  options={eventOptions}
                  value={eventFilter}
                  onChange={setEventFilter}
                  searchable
                />
                <SelectWithInternalLabel
                  defaultOption2
                  label={intl.formatMessage({
                    id: "area",
                  })}
                  options={areaOptions}
                  value={areaFilter}
                  onChange={setAreaFilter}
                  searchable
                />
              </FlexContainer>
            </FlexContainer>
            <NewButton onClick={() => history.push("/admin/totem-form")}>
              <FaPlus />
              {intl.formatMessage({ id: "register_new_totem" })}
            </NewButton>
          </TitleContainer>
          {filteredTotems.length === 0 && <Empty />}
          <ContentContainer>
            {filteredTotems.map((item) => (
              <>
                <Cards key={item.id}>
                  <CardHeader>
                    <div>
                      <LabelInfo>
                        <strong>{intl.formatMessage({ id: "event" })}: </strong>
                        {item.eventEditionName}
                      </LabelInfo>
                      <LabelInfo>
                        <strong> {intl.formatMessage({ id: "area" })} </strong>{" "}
                        {item.areaName}{" "}
                      </LabelInfo>
                    </div>

                    <IconsDiv>
                      <DeleteIcon
                        onClick={() => {
                          setSelectedIdToDelete(item.id);
                          setModalIsOpen(true);
                        }}
                        size={24}
                      />
                    </IconsDiv>
                  </CardHeader>

                  <Divider />

                  <ViewButton
                    onClick={() => history.push(`/admin/totem-form/${item.id}`)}
                  >
                    <FiExternalLink size={20} />
                    {intl.formatMessage({ id: "view_totem_access" })}
                    {item.hasActiveTotemSession && (
                      <Tooltip
                        title={intl.formatMessage({
                          id: "active_totem_sessions_tooltip_warning",
                        })}
                        placement="top"
                      >
                        <MdWarning
                          size={20}
                          color="#DC2626"
                          style={{ marginLeft: "8px", cursor: "help" }}
                        />
                      </Tooltip>
                    )}
                  </ViewButton>
                </Cards>
              </>
            ))}
          </ContentContainer>
        </Container>
      </Spin>
      <ConfirmationModal
        setIsOpen={setModalIsOpen}
        modalIsOpen={modalIsOpen}
        confirmationFunction={() => handleDeleteTotem(selectedIdToDelete)}
        description={intl.formatMessage({
          id: "delete_totem_confirmation",
        })}
        confirmationText={intl.formatMessage({ id: "yes" })}
        cancelText={intl.formatMessage({ id: "no" })}
      />
    </AnimatedMainContainer>
  );
};

export default AdminManegeTotemAccess;
